function uploadArtwork() {
  const uploadArtworkFields = document.querySelector('[data-artwork-upload-fields]');
  const maxQuantity = parseInt(uploadArtworkFields.dataset.maxQuantity, 10);
  const chooseButton = document.querySelector('[data-choose-artwork-button]');
  const skipUploadBtn = document.querySelector('[data-skip-upload-btn]');
  const addToCartBtn = document.querySelector('[data-add-to-cart-btn]');
  const step1 = document.querySelector('[data-artwork-upload-step-1]');
  const step2 = document.querySelector('[data-artwork-upload-step-2]');
  const backBtn = document.querySelector('[data-request-quote-back-btn]');

  // Parse URL params
  const url = window.location.href;
  const info = url.split('?')[1];
  const infoID = info.split('&')[0].split('=')[1];
  const infoSize = info.split('&')[1].split('=')[1];
  let infoQty = info.split('&')[2].split('=')[1];
  const infoProductTitle = info.split('&')[3].split('=')[1].replace(new RegExp('-', 'g'), ' ');
  const infoUrl = info.split('&')[4].split('=')[1];
  const str = infoUrl.split('/');
  const productHandle = str[str.length - 1].replace('#', '');
  const infoTier = info.split('&')[5].split('=')[1];

  // Custom quantity
  if (infoQty.indexOf('c_') > -1) {
    infoQty = infoQty.split('_')[1];
    infoQty = (parseInt(infoQty, 10) > maxQuantity) ? maxQuantity : infoQty;
  }

  if (infoUrl) {
    backBtn.href = infoUrl;
  }

  chooseButton.addEventListener('click', () => {
    step1.classList.add('hide');
    step2.classList.remove('hide');
  });

  skipUploadBtn.addEventListener('click', handleAddToCart);
  addToCartBtn.addEventListener('click', handleAddToCart);

  function handleAddToCart(event) {
    const lineItemProperties = {
      _customProductId: `${productHandle}_${Date.now()}`,
    };

    const comment = document.querySelector('[data-artwork-instructions]').value;

    if (event.currentTarget === addToCartBtn) {
      const artworkUrl = document.querySelector('[data-uploaded-image]').value;
      lineItemProperties._artworkUrl = artworkUrl;
    }

    if (infoTier !== '') {
      lineItemProperties._quantityTier = infoTier;
    }

    if (infoSize !== '') {
      lineItemProperties._size = infoSize;
    }

    if (comment !== '') {
      lineItemProperties._comment = comment;
    }

    const lineItem = {
      quantity: infoQty,
      id: infoID,
      properties: lineItemProperties,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(lineItem),
    }).then((response) => {
      return response.json();
    }).then((result) => {
      if (result.status) {
        throw new Error(result.description);
      }
      window.location.replace('/cart');
    }).catch((error) => {
      alert(error);
    });
  }
}

function uploadCareWidget() {
  // Uploadcare script
  const widget = uploadcare.Widget('[role="uploadcare-uploader"]');

  // Restyle upload buttons
  const uploadBtn = document.querySelector('.uploadcare--widget__button_type_open');
  const removeBtn = document.querySelector('.uploadcare--widget__button_type_remove');
  uploadBtn.classList.add('btn', 'btn--gradient', 'btn--full');
  uploadBtn.textContent = 'CHOOSE A FILE – JPEG, PNG or PDF';
  removeBtn.textContent = '';

  widget.onUploadComplete((info) => {
    saveImage(info.cdnUrl).then(() => {
      document.querySelector('#submit-quote').style.display = 'block';
      document.querySelector('.skip-upload').style.display = 'none';
    }).catch((error) => {
      console.log(error);
    });
  });

  let images = [];

  fetchImages().then(uploadedImages => {
    images = uploadedImages;
    const imageHtml = images.reduce((html, url) => {
      const fullUrl = `${url}/-/preview/-/scale_crop/200x200/`;

      return (
        `${html
        }<div class="col" >` +
        '<a href="#" class="d-block mb-4 h-100">' +
        `<img class="img-fluid img-thumbnail" src="${fullUrl}">` +
        '</a>' +
        '</div>'
      );
    }, '');

    document.querySelector('#imagesContainer').insertAdjacentHTML('beforeend', imageHtml);
  }).catch((error) => {
    console.log(error);
  });

  function fetchImages() {
    return new Promise(resolve => {
      images = JSON.parse(localStorage.getItem('images') || '[]');
      setTimeout(() => resolve(images), 500);
    });
  }

  function saveImage(url) {
    return new Promise(resolve => {
      images.push(url);
      localStorage.setItem('images', JSON.stringify(images));
      setTimeout(() => resolve(), 500);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  uploadArtwork();
  uploadCareWidget();
});

document.addEventListener('shopify:section:load', () => {
  uploadArtwork();
  uploadCareWidget();
});
